module.exports = __webpack_public_path__ + "img/image4.2a609ea7.jpg";